<template>
	<widget title="Recent Construction News" icon="fa-envelope" :max-height="maxHeight">
		<div class="articles">
			<article v-for="(post,index) in posts" class="blog-article mb-2" :class="{active: index == activeIndex}" v-on:mouseover="mouseOver = true" v-on:mouseleave="mouseOver = false">
				<div class="row" :class="{'align-items-center':!('showSummary' in post) || !post.showSummary}">
					<div class="col-sm-3">
						<a v-if="post.featured_image" :href="post.url" v-on:click.prevent="trackOutbound" target="_blank"><img :src="post.featured_image" class="mb-2"></a>
						<p class="text-muted text-center">{{post.publish_date}}</p>
					</div>
					<div class="col-sm-9">
						<h1><a :href="post.url" v-on:click.prevent="trackOutbound" target="_blank">{{post.title}}</a></h1>

						<div v-if="'showSummary' in post && post.showSummary" >
							<p><a href="#" v-on:click.prevent="post.showSummary = false">hide preview...</a></p>
							<div v-html="post.post_list_content" class="summary"></div>
							<p><a :href="post.url" v-on:click.prevent="trackOutbound" target="_blank" class="btn btn-sm btn-primary">Read full Post</a></p>
						</div>

						<a v-else href="#" v-on:click.prevent="$set(post,'showSummary',true)">read more...</a>
					</div>
				</div>
			</article>
		</div>

	</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"

export default {
	name: "NewsWidget",
	components: {
		Widget
	},
	props: ["maxHeight"],
	data() {
		return {
			activeIndex: 0,
			mouseOver: false,
			newsFeeds: [
				{
					label: "DataBid",
					apiUrl: "https://databid.tradetraks.ca/blog/",
					fieldMap: {
						publish_date: 'publish_date',
						url: 'url',
						title: 'title',
						post_list_content: 'post_list_content',
						featured_image: 'featured_image'
					},
					queryMap: {
						limit: 'limit'
					},
					resultProperty: 'objects'
				},
				{
					label: "Ontario Construction News",
					apiUrl: "https://ontarioconstructionnews.com/wp-json/wp/v2/posts",
					fieldMap: {
						publish_date: 'date',
						url: 'link',
						title: 'title.rendered',
						post_list_content: 'excerpt.rendered',
						featured_image: 'jetpack_featured_media_url'
					},
					queryMap: {
						limit: 'per_page'
					},
					resultProperty: false
				},
				{
					label: "Canadian Contractor",
					apiUrl: "https://www.canadiancontractor.ca/wp-json/wp/v2/posts",
					fieldMap: {
						publish_date: 'date',
						url: 'link',
						title: 'title.rendered',
						post_list_content: 'excerpt.rendered',
						featured_image: 'jetpack_featured_media_url'
					},
					queryMap: {
						limit: 'per_page'
					},
					resultProperty: false
				}
			],

			
			/**
				[{
					publish_date: date string (MMM DD, YYYY),
					url: string
					showSummary: boolean,
					title: string,
					post_list_content: string (html),
					featured_image: string (img src url)
				}]
			*/
			posts: []
		}
	},
	mutatedPosts() {
		
	},
	methods: {
		setOutboundTracking(link) {
			return window.apiRoot+"outbound?userSlug="+this.$store.userDetails.slug+"&link="+link+"&source=TradetraksNewsWidget"
		},
		trackOutbound(e) {
			//If clicked element is not an anchor link (like an image wrapped in an anchor), we need to traverse up the DOM nodes to find the anchor link
			if (e.srcElement.tagName != 'A') {
				//find path up to nearest anchor link
				e.path.forEach(node => {
					if (node.tagName == 'A')
						window.open(this.setOutboundTracking(node.href))
				})
			}
			else //anchor link clicked directly
				window.open(this.setOutboundTracking(e.srcElement.href))
		},
		mergeAndMutatePosts(databidPosts, ocnPosts) {
			let vm = this

			let posts = []

			if (databidPosts) {
				posts = databidPosts.map(post => {
					let showSummary = false
					if ("post_list_content" in post && post.post_list_content)
						showSummary = true

					return {
						publish_date: vm.moment(post.publish_date).format("MMM DD, YYYY"),
						publish_timestamp: +vm.moment(post.publish_date).format("X"),
						url: post.url,
						showSummary: showSummary,
						title: post.title,
						post_list_content: post.post_list_content,
						featured_image: vm.getFeaturedImage(post)
					}
				})
			}

			if (ocnPosts) {
				posts = posts.concat(ocnPosts.map(post => {
					let showSummary = false
					let excerpt = ""
					if ("excerpt" in post && "rendered" in post.excerpt) {
						showSummary = true
						excerpt = post.excerpt.rendered
					}

					return {
						publish_date: vm.moment(post.date).format("MMM DD, YYYY"),
						publish_timestamp: +vm.moment(post.date).format("X"),
						url: post.link,
						showSummary: showSummary,
						title: post.title.rendered,
						post_list_content: excerpt,
						featured_image: vm.getFeaturedImage(flattenedPost)
					}
				}))
			}

			//sort by date
			posts.sort((a,b) => {
				if (a.publish_timestamp < b.publish_timestamp)
					return 1
				else
					return -1
			})

			return posts.slice(0,5)
		},
		getFeaturedImage(post) {
			let featured_image = false
			if ("featured_image" in post)
				featured_image = post.featured_image
			else if ("jetpack_featured_media_url" in flattenedPost)
				featured_image = post.jetpack_featured_media_url

			return featured_image
		},
		mutatePostsFromSource(posts,feedSettings) {
			let vm = this
			console.log(posts)
			if (posts) {
				return posts.map(post => {

					let flattenedPost = {}
					Object.keys(feedSettings.fieldMap).forEach(key => {

						let originalKey = feedSettings.fieldMap[key]

						if (feedSettings.fieldMap[key].indexOf(".") >= 0) {
							//has subproperties
							let props = feedSettings.fieldMap[key].split(".")
							let value = post
							//iterate into nested properties
							props.forEach(prop => {
								value = value[prop]
							})
							flattenedPost[key] = value
						}
						else 
							flattenedPost[key] = originalKey in post ? post[originalKey] : false
					})

					let showSummary = true

					let newPost = {
						publish_date: vm.moment(flattenedPost.publish_date).format("MMM DD, YYYY"),
						publish_timestamp: +vm.moment(flattenedPost.publish_date).format("X"),
						url: flattenedPost.url,
						showSummary,
						title: flattenedPost.title,
						post_list_content: flattenedPost.post_list_content,
						featured_image: vm.getFeaturedImage(flattenedPost),
						source: feedSettings.label
					}

					return newPost

				})
			}
			return []
		},
		fetchPosts() {
			let vm = this

			//let options = {fullUrl: true,omitApiKey: true}

			let promises = []

			this.newsFeeds.forEach(feed => {
				let params = {
					url: feed.apiUrl
				}

				params[feed.queryMap.limit] = 4 //set max results

				let proxyUrl = "Proxy/request"

				promises.push(this.getJSON(proxyUrl,params,false))
			})

			Promise.all(promises).then(responses => {

				responses.forEach((response,index) => {
					let posts = JSON.parse(response.data)

					if (vm.newsFeeds[index].resultProperty)
						posts = response[vm.newsFeeds[index].resultProperty]

					vm.posts = [
						...vm.posts,
						...vm.mutatePostsFromSource(posts,vm.newsFeeds[index])
					]
				})

				//sort by date
				vm.posts = vm.posts.sort((a,b) => {
					if (a.publish_timestamp < b.publish_timestamp)
						return 1
					else
						return -1
				})
			})
		}
	},
	created() {
		this.fetchPosts()

		let vm = this
		let carouselTimer = setInterval(() => {
			if (!vm.mouseOver) {
				vm.activeIndex++
				if (vm.activeIndex > vm.posts.length-1)
					vm.activeIndex = 0
			}
		},5000)
	}
}
</script>

<style type="text/css" scoped>
	.articles {
		position: relative;
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.blog-article {
		opacity: 0;
		z-index: 0;
		position: absolute;
		top: 10px;
		left: 0px;
		width: 100%;
		transition: 1s opacity;
	}

	.blog-article.active {
		display: block;
		position: absolute;
		z-index: 1;
		opacity: 1;
	}

	.blog-article h1 {
		font-size: 16pt;
	}

	.small-print {
		position: absolute;
		bottom: -10px;
		z-index: 3;
		background: white;
	}
</style>